import { defineStore } from 'pinia';
import type { PageData } from '~~/server/pageData';
import type { ProductXapiResponse } from '~~/shared/globalTypes/XapiResponse';

export default defineStore('pageDataStore', {
  state: () =>
    <{ pageData: PageData; pageUtagData: object | null }>{
      pageData: null as unknown as PageData, // hard typing to PageData since its always initialized first and will never be null
      pageUtagData: null,
    },
  getters: {
    product(): ProductXapiResponse | null {
      // TODO i think this is unused and can be removed
      return this.pageData?.product || null;
    },
  },
});
